import * as React from 'react';
import CenteredPageContainer from 'components/Layout/CenteredPageContainer';
import TermsAndConditionsView from 'components/Information/TermsAndConditionsView';

export interface Props {
  children?: React.ReactNode;
}

export interface State {}

export default class TermsAndConditionsPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <CenteredPageContainer title="Terms and Conditions">
        <TermsAndConditionsView />
      </CenteredPageContainer>
    );
  }
}
